import { useEffect, useState } from 'react';
import { getMaintenanceStatus } from '../../pages/api';


export default function useMaintenanceStatus() {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [maintenanceMsg, setMaintenanceMsg] = useState('');

  useEffect(() => {
    const controller = new AbortController();

    const fetchStatus = async () => {
      try {
        const response = await getMaintenanceStatus({ signal: controller.signal });
        if (response?.data?.user?.maintenance) {
          setIsMaintenance(true);
          setMaintenanceMsg(response?.data?.user?.message || 'We’re undergoing maintenance.');
        } else {
          setIsMaintenance(false);
        }
      } catch (err) {
        console.error('Maintenance status fetch failed:', err);
      }
    };

    fetchStatus();
    return () => controller.abort();
  }, []);

  return { isMaintenance, maintenanceMsg };
}
